import { useNavigate } from 'react-router-dom';
import TopBarHeader from '@/domains/mobile-web/components/TopBarHeader/TopBarHeader';
import {
  TNC_CLOSING,
  TNC_INTRO,
  TNC_SECTIONS,
  TNC_TITLE,
  type TncSection,
} from '@/domains/mobile-web/constant/tnc.constant';
import WrapperMobile from '@/shared/components/layout/WrapperMobile/WrapperMobile';
import HeaderMobile from '@/shared/components/ui/HeaderMobile/HeaderMobile';
import Seo from '@/shared/components/ui/Seo/Seo';

const PrivacyPolice = () => {
  const navigate = useNavigate();
  return (
    <>
      <Seo
        title="Kebijakan Privasi"
        description="Kebijakan dan privasi penggunaan website dan layanan Rumah Kebijaksanaan: pendaftaran akun, pembelian buku, pengembalian, program afiliasi, donasi dan permintaan buku."
        path="/store/privacy-police"
      />
      <HeaderMobile>
        <TopBarHeader type="back" title="Kebijakan Privasi" onBack={() => navigate(-1)} />
      </HeaderMobile>
    </>
  );
};

export default PrivacyPolice;
